<div id="wrapper">
  <app-menu></app-menu>
  <div class="allcont logsize">
    <div class="basicrow m-top">
      <div class="container">
        <div class="basicrow m-top">
          <div class="row">
            <div class="col-md-6 col-lg-7 hidden-xs hidden-sm text-center mob-hid">
              <img width="100%" class="neg-img" src="../../assets/images/Wholesale_login.png">
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5 log-mob mob-pos">
              <form class="logside log-mob-b" [formGroup]="loginForm">
                <div class="basicrow f-bigmed roboto-m">
                  <img width="100%" class="mc-icon" src="../../assets/images/miclaro-icon.png"> Autenticaci&oacute;n
                </div>

                <div class="basicrow m-top">
                  <label class="label-f">Usuario</label>

                  <div class="basicrow">
                    <input placeholder=""  (keypress)="this.global.validateInputKey($event)" (blur)="this.global.validateInputKey($event)"
                      class="inp-f" required formControlName="username" id="username">
                    <div [hidden]="loginForm.controls.username.valid || loginForm.controls.username.untouched"
                      class="alert alert-danger">
                      Usuario Requerido
                    </div>
                  </div>
                </div>

                <div class="basicrow m-top-i">
                  <label class="label-f">Contrase&ntilde;a</label>

                  <div class="basicrow">
                    <input (blur)="this.global.validateInputKey($event)"
                      (keypress)="this.getIn($event);" class="inp-f" required formControlName="password" id="password"
                      type="password">
                    <div [hidden]="loginForm.controls.password.valid || loginForm.controls.password.untouched"
                      class="alert alert-danger">
                      Contraseña Requerida
                    </div>
                  </div>
                </div>

                <div class="basicrow roboto-r f-reg m-top">
                  <input type="checkbox" formControlName="remember" (click)="changeRememberMe()"> Recordar Usuario
                </div>

                <div class="basicrow m-top-i">
                  <div class="row">
                    <div class="col-xs-12 col-md-6 col-lg-6 hidden-xs">
                      <a (click)="clean()" class="btns gray vcenter">
                        <span class="tabcell">
                          Borrar&nbsp;&nbsp;<i class="fa fa-times" aria-hidden="true"></i>
                        </span>
                      </a>
                    </div>

                    <div class="col-xs-12  col-md-6 col-lg-6">
                      <a (click)="login()" class="btns red vcenter"
                        [ngClass]="{'red': !loginForm.invalid, 'gray': loginForm.invalid}">
                        <span class="tabcell">
                          Ingresar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>

                <div class="basicrow text-center m-top-ii">
                  <a routerLink="/forgotpassword" href="/forgotpassword" class="linkdefs">¿Olvidaste tu contraseña?&nbsp;&nbsp;<i
                      class="fa fa-angle-right" aria-hidden="true"></i></a>
                </div>
                <div class="basicrow m-top-u-ii">

                  <a routerLink="/register" class="btns blue vcenter">
                    <span class="tabcell">
                      ¿No tienes cuenta? Regístrate&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="log-gbg visible-lg">
      <div class="container">
        <div class="basicrow f-bigmed roboto-l">
          <span class="roboto-r f-big">&#191;Qué es Mi Claro Wholesale&#63;</span><br />
          Mi Claro Wholesale es una aplicaci&oacute;n segura y f&aacute;cil de usar para el manejo de sus cuentas con
          Claro PR.<br /><br />

          Mi Claro Wholesale le permite ver:
        </div>

        <div class="basicrow f-med roboto-l">
          <ul class="redb-list">
            <li class="li1"> Ver detalles de sus facturas.</li>
            <li class="li2">Pagar sus facturas.</li>
            <li class="li3">Ver el histórico de sus pagos.</li>
            <li class="li4">Descargar sus facturas en formatos de PDF y CSV.</li>
            <li class="li5">Ver las información registrada en Mi Perfil.</li>
            <li class="li6">Ver información de Soporte.</li>
            <li class="li7">Escoger preferencia de notificaciones.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
